import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScIntroWrapper = styled.div`
  position: relative;
  margin-top: -32px;
  @media (${device.mobile}) {
    margin-top: -16px;
  }
`;

export const ScIntroBg = styled.div`
  position: absolute;
  inset: 0;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  z-index: 0;
  pointer-events: none;
`;

export const ScIntroSection = styled.section`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  place-items: center;
  justify-content: center;
  align-items: center;
  height: 360px;
  gap: 24px;

  & .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .title {
      ${typography.headline1};
      font-weight: 700;
      text-transform: uppercase;
    }

    & .description {
      ${typography.body1bold};
      font-weight: 400;
    }
  }

  @media (${device.tablet}) {
    gap: 24px;
    height: 264px;
    & .text-wrapper {
      & .title {
        text-align: center;
        ${typography.headline2};
      }
      & .description {
        text-align: center;
      }
    }
  }

  @media (${device.mobile}) {
    grid-template-columns: 1fr;
    gap: 0;
    height: 100%;
    & .text-wrapper {
      gap: 12px;
    }
  }
`;

export const ScCardWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .intro-img {
    position: relative;
    z-index: 1;
  }

  .card-anim-bg {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    max-width: unset;
    pointer-events: none;
    z-index: 0;
  }

  @media (${device.mobile}) {
    width: 100%;
    max-width: 344px;
    margin-top: 16px;

    .intro-img {
      width: 300px;
      height: 153px;
    }

    .card-anim-bg {
      width: min(390px, 100vw);
      height: 257px;
    }
  }
`;
